export const BRAND = {
  name: "NEPHRC",
  full: "North East Projects, Hospitality & Retails Consultancy",
  founder: "T G Dey",
  tagline: "Engineering Tomorrow.",
  taglineSecondary: "Transforming Infrastructure, Hospitality & Retail.",
  description:
    "NEPHRC delivers multidisciplinary consultancy solutions across engineering, architecture, project management, hospitality, retail and infrastructure development throughout India.",
};

export const CONTACT = {
  phones: ["+91 7005185934", "+91 9402303338", "0364-2954132"],
  primaryPhone: "+917005185934",
  whatsappPhone: "917005185934",
  email: "neconsultancyindia@gmail.com",
};

export const buildWhatsAppLink = (message) =>
  `https://wa.me/${CONTACT.whatsappPhone}?text=${encodeURIComponent(message)}`;

export const OFFICES = [
  {
    name: "Head Office",
    city: "Shillong, Meghalaya",
    address: "Mawlai Umshing, Shillong, Meghalaya – 793022",
    mapQuery: "Mawlai Umshing Shillong Meghalaya 793022",
  },
  {
    name: "Assam Office",
    city: "Guwahati, Assam",
    address: "House No. 52, Hill View Road, Jyotikuchi, Guwahati – 781034",
    mapQuery: "Jyotikuchi Guwahati Assam 781034",
  },
  {
    name: "Delhi Office",
    city: "New Delhi",
    address: "London House, B1, 2nd Floor, Vasant Kunj, New Delhi – 110070",
    mapQuery: "Vasant Kunj New Delhi 110070",
  },
  {
    name: "Nagaland Office",
    city: "Dimapur, Nagaland",
    address: "NEPHRC Building, Bank Colony, Dimapur – 797112",
    mapQuery: "Bank Colony Dimapur Nagaland 797112",
  },
  {
    name: "Nagaland (Purana Bazar)",
    city: "Dimapur, Nagaland",
    address: "House No. 775 GBC, Purana Bazar, Dimapur – 797116",
    mapQuery: "Purana Bazar Dimapur Nagaland 797116",
  },
];

export const NAV_LINKS = [
  { label: "Home", to: "/" },
  { label: "About", to: "/about" },
  { label: "Founder", to: "/founder" },
  { label: "Leadership", to: "/leadership" },
  { label: "Services", to: "/services" },
  { label: "Projects", to: "/projects" },
  { label: "Industries", to: "/industries" },
  { label: "Partners", to: "/partners" },
  { label: "Careers", to: "/careers" },
  { label: "Contact", to: "/contact" },
];

export const HERO_STATS = [
  { label: "Projects Completed", value: 240, suffix: "+" },
  { label: "Years of Experience", value: 18, suffix: "+" },
  { label: "Expert Engineers", value: 75, suffix: "+" },
  { label: "Offices Across India", value: 5, suffix: "" },
];

export const WHY_CHOOSE = [
  {
    title: "Multidisciplinary Team",
    description:
      "Engineers, architects, planners and consultants under one roof, collaborating to deliver outcomes that exceed expectations.",
  },
  {
    title: "Innovative Engineering",
    description:
      "Forward-looking design powered by BIM, GIS and digital twins — engineered for resilience and longevity.",
  },
  {
    title: "Government Project Expertise",
    description:
      "Empanelled experience executing public infrastructure, institutional and PSU mandates across India.",
  },
  {
    title: "Sustainable by Design",
    description:
      "Low-carbon materials, green building certifications and climate-adaptive design baked into every commission.",
  },
  {
    title: "End-to-End Consultancy",
    description:
      "From feasibility and DPR through construction supervision to monitoring — a single accountable partner.",
  },
  {
    title: "On-Time Delivery",
    description:
      "Rigorous program management with weekly cadences and milestone-locked schedules.",
  },
  {
    title: "Transparent Communication",
    description:
      "Open dashboards, plain-language reporting and clear escalation paths — never a surprise.",
  },
  {
    title: "Client-First Approach",
    description:
      "Your business goals frame our scope. We adapt our process to your governance and reporting needs.",
  },
];

export const PROCESS_STEPS = [
  { n: "01", title: "Consultation", body: "Discover your goals, constraints and success metrics." },
  { n: "02", title: "Feasibility Study", body: "Technical, financial and regulatory feasibility appraisal." },
  { n: "03", title: "Survey & Investigation", body: "Topography, geotechnical, hydrological and traffic surveys." },
  { n: "04", title: "Planning", body: "Master-planning, zoning and site optimisation strategy." },
  { n: "05", title: "Engineering Design", body: "Architectural, structural, MEP and infrastructure design." },
  { n: "06", title: "DPR Preparation", body: "Bankable Detailed Project Reports with BOQ and cost estimates." },
  { n: "07", title: "Construction Support", body: "Tender management, vendor selection and contract administration." },
  { n: "08", title: "Monitoring", body: "Quality, safety, schedule and budget surveillance on-site." },
  { n: "09", title: "Completion", body: "Handover, commissioning and post-occupancy evaluation." },
];

export const COMPANY_VALUES = [
  { title: "Integrity", body: "We honour our commitments and report with candour." },
  { title: "Engineering Excellence", body: "Design discipline, rigorous review, defensible outcomes." },
  { title: "Sustainability", body: "Low-carbon, climate-adaptive, community-positive." },
  { title: "Innovation", body: "Digital workflows, BIM, GIS and parametric design." },
  { title: "Collaboration", body: "One team across disciplines, geographies and clients." },
  { title: "Accountability", body: "Owning the outcome from feasibility to commissioning." },
];
